import ReactMarkdown from 'react-markdown'
import { Box, Heading, Text, VStack } from '@chakra-ui/react'
import type { LobbyPacketDto } from '../../../types/lobbyDay'
import { proseContentCss } from '../../../theme/proseStyles'

export function PrintPacketCard({ packet }: { packet: LobbyPacketDto }) {
  return (
    <Box className="print-packet-card" p={3} mb={3} borderWidth="1px" borderRadius="md">
      <Heading size="sm">
        {packet.legislatorName}{packet.legislatorParty ? ` (${packet.legislatorParty})` : ''} · {packet.districtLabel}
      </Heading>
      <Text fontSize="sm" color="muted">
        {packet.meetingDate} · {packet.startTime}–{packet.endTime}{packet.room ? ` · Room ${packet.room}` : ''}
      </Text>
      {packet.askTitle && <Text mt={2} fontWeight="medium">{packet.askTitle}{packet.billNumber ? ` (${packet.billNumber})` : ''}</Text>}
      <VStack align="stretch" gap={2} mt={2} css={proseContentCss}>
        {packet.talkingPointsMarkdown && <Box><Text fontWeight="semibold">Talking points</Text><ReactMarkdown>{packet.talkingPointsMarkdown}</ReactMarkdown></Box>}
        {packet.linkedBills.map((b) => (
          <Box key={b.billNumber}>
            <Text fontWeight="semibold">Official summary{b.billNumber ? ` · ${b.billNumber}` : ''}</Text>
            {b.summary && <Text fontSize="sm">{b.summary}</Text>}
            {b.fullTextUrl && <Text fontSize="xs" color="muted">Full text: {b.fullTextUrl}</Text>}
          </Box>
        ))}
        {packet.billMarkdown && <Box><Text fontWeight="semibold">Bill notes</Text><ReactMarkdown>{packet.billMarkdown}</ReactMarkdown></Box>}
        {packet.legislatorBackgroundMarkdown && <Box><Text fontWeight="semibold">Background</Text><ReactMarkdown>{packet.legislatorBackgroundMarkdown}</ReactMarkdown></Box>}
        {packet.meetingNotesMarkdown && <Box><Text fontWeight="semibold">Notes</Text><ReactMarkdown>{packet.meetingNotesMarkdown}</ReactMarkdown></Box>}
        {packet.coAttendees.length > 0 && <Text fontSize="sm" color="muted">With: {packet.coAttendees.join(', ')}</Text>}
        {packet.attachments.length > 0 && (
          <Box>
            <Text fontWeight="semibold">Documents</Text>
            {packet.attachments.map((a) => (
              <Text key={a.id} fontSize="sm">· {a.title}</Text>
            ))}
          </Box>
        )}
      </VStack>
    </Box>
  )
}
